<div class="manage-users-headers">
  <div class="page-title">CDFI Outreach Logs</div>
  @if (cdfiOutreachLogs.length > 0) {
    <div class="page-size">
      <app-page-size
        [pageSize]="pageSize"
        [selectId]="'cdfi-outreach-logs'"
        (pageSizeChanged)="onPageSizeChange($event)"
      ></app-page-size>
    </div>
  }
</div>

<div class="tabs-container">
  <div class="tabs">
    @for (tab of tabs; track tab.id) {
      <button
        class="tab"
        [class.active]="activeTab === tab.id"
        (click)="onTabChange(tab.id)"
      >
        {{ tab.label }}
      </button>
    }
  </div>
</div>

<app-cdfi-outreach-logs-dashboard
  [outreachType]="getCurrentOutreachType()"
  [source]="getCurrentSource()"
></app-cdfi-outreach-logs-dashboard>

<div class="filter-search-section">
  <div class="filter-controls">
    <div class="page-filter">
      <app-filter
        [filterBy]="filterBy"
        [label]="'Form Status:'"
        [filterByOptions]="filterByOptions"
        (filterByChanged)="onFilterByChange($event)"
      ></app-filter>
    </div>
    <div class="active-clients-toggle">
      <label class="checkbox-container">
        <input
          type="checkbox"
          [(ngModel)]="showActiveClientsOnly"
          (change)="onActiveClientsToggle()"
        />
        <span class="checkbox-label">Show Active Clients Only</span>
      </label>
    </div>
  </div>
  <div class="search-section-wrapper">
    <app-search-input
      [placeholder]="'Search Business ...'"
      [(searchQuery)]="searchQuery"
      (searchQueryChange)="onSearchQueryChange($event)"
    ></app-search-input>
  </div>
</div>

<app-cdfi-outreach-logs-table
  [cdfiOutreachLogs]="cdfiOutreachLogs"
  [loading]="loading"
  [pageSize]="pageSize"
  [showActiveClientColumn]="showActiveClientsOnly"
  (pageSizeChange)="onPageSizeChange($event)"
></app-cdfi-outreach-logs-table>

@if (cdfiOutreachLogs.length > 0) {
  <app-pagination
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalItems]="totalCDFIOutreachLogs"
    (pageChanged)="onPageChange($event)"
  ></app-pagination>
}
